import { render, staticRenderFns } from "./edit-room.vue?vue&type=template&id=2e043a7b&scoped=true&"
import script from "./edit-room.vue?vue&type=script&lang=js&"
export * from "./edit-room.vue?vue&type=script&lang=js&"
import style0 from "./edit-room.vue?vue&type=style&index=0&id=2e043a7b&prod&lang=css&"
import style1 from "./edit-room.vue?vue&type=style&index=1&id=2e043a7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e043a7b",
  null
  
)

export default component.exports